export const API_URL =process.env.API_URL || "https://pramaanpatra.onrender.com";
// export const API_URL = "http://localhost:8080";